import { Trans } from '../../atoms'
import { priceNotation } from '../../../utils/safe'

const OrdineTotale = ({ ordine }) => {
  return (
    <>
      <div className="ordine-totale">
        <h3 className="ordine-totale__title">
          <Trans chiave="Totali ordine" />
        </h3>
        <div className="ordine-totale__row">
          <span>
            <Trans chiave="Valore merce (inclusa eventuale Siae):" />
          </span>
          <span>{priceNotation(ordine.valore_merce + ordine.valore_siae, 2)} €</span>
        </div>
        <div className="ordine-totale__row">
          <span>
            <Trans chiave="Costo personalizzazione (incluso eventuale confezionamento):" />
          </span>
          <span>
            {priceNotation(ordine.valore_personalizzazione + ordine.valore_confezionamento, 2)} €
          </span>
        </div>
        <div className="ordine-totale__row">
          <span>
            <Trans chiave="Costo impianti, avviamento e tracciatura logo:" />
          </span>
          <span>
            {priceNotation(
              ordine.valore_impianto + ordine.valore_gestione + ordine.valore_tracciatura_logo,
              2
            )}{' '}
            €
          </span>
        </div>
        {ordine?.valore_supplementi_minimi_stampa > 0 && (
          <div className="ordine-totale__row">
            <span>
              <Trans chiave="Costo supplementi minimi di stampa:" />
            </span>
            <span>{priceNotation(ordine.valore_supplementi_minimi_stampa, 2)} €</span>
          </div>
        )}
        <div className="ordine-totale__row">
          {ordine.valore_ritiro ? (
            <>
              <span>
                <Trans chiave="Costo ritiro:" />
              </span>
              <span>{priceNotation(ordine.valore_ritiro, 2)} €</span>
            </>
          ) : (
            <>
              <span>
                <Trans chiave="Costo spedizione:" />
              </span>
              <span>{priceNotation(ordine.valore_trasporto, 2)} €</span>
            </>
          )}
        </div>
        <div className="ordine-totale__row">
          <span>
            <Trans chiave="Sconti" />
            {':'}
          </span>
          <span>
            {priceNotation(
              ordine.valore_sconto_imballi_integri +
                ordine.valore_sconto_merce +
                ordine.valore_sconto_personalizzazione +
                ordine.valore_sconto_gestione +
                ordine.valore_sconto_impianto +
                ordine.valore_sconto_trasporto,
              2
            )}{' '}
            €
          </span>
        </div>
        <div className="ordine-totale__row">
          <span>
            <Trans chiave="Totale imponibile:" />
          </span>
          <span>{priceNotation(ordine.totale_imponibile, 2)} €</span>
        </div>
        <div className="ordine-totale__row">
          <span>
            <Trans chiave="IVA:" />
          </span>
          <span>{priceNotation(ordine.totale_imposta, 2)} €</span>
        </div>
        <div className="ordine-totale__row ordine-totale__row--big">
          <span>
            <Trans chiave="Totale complessivo:" />
          </span>
          <span>{priceNotation(ordine.totale, 2)} €</span>
        </div>
      </div>
    </>
  )
}

export default OrdineTotale
